import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../../services/api";
import { uploadImageToCloudinary } from "../../services/cloudinary";

const AdminPayment = () => {
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState({ momo: false, banking: false });
  
  const [momoConfig, setMomoConfig] = useState({
    phone: "",
    accountHolder: "",
    qrImage: "",
  });
  const [bankingConfig, setBankingConfig] = useState({
    bankName: "",
    accountNumber: "",
    accountHolder: "",
    bin: "",
    qrImage: "",
  });

  useEffect(() => {
    fetchConfigs();
  }, []);

  const fetchConfigs = async () => {
    setLoading(true);
    try {
      const [momoRes, bankingRes] = await Promise.all([
        api.get("/settings/payment_momo_config"),
        api.get("/settings/payment_banking_config"),
      ]);
      if (momoRes.data) setMomoConfig({ ...momoRes.data, qrImage: momoRes.data.qrImage || "" });
      if (bankingRes.data) setBankingConfig({ ...bankingRes.data, qrImage: bankingRes.data.qrImage || "" });
    } catch (error) {
      console.error("Error fetching configs:", error);
      toast.error("Không thể tải cấu hình thanh toán");
    } finally {
      setLoading(false);
    }
  };

  const handleImageUpload = async (file, type) => {
    if (!file) return;
    
    setUploading(prev => ({ ...prev, [type]: true }));
    try {
      const url = await uploadImageToCloudinary(file);
      if (type === "momo") {
        setMomoConfig(prev => ({ ...prev, qrImage: url }));
      } else {
        setBankingConfig(prev => ({ ...prev, qrImage: url }));
      }
      toast.success("Tải ảnh lên thành công");
    } catch (error) {
      toast.error("Lỗi khi tải ảnh lên Cloudinary");
      console.error(error);
    } finally {
      setUploading(prev => ({ ...prev, [type]: false }));
    }
  };

  const handleUpdateMomo = async () => {
    setLoading(true);
    try {
      await api.put("/admin/settings/payment_momo_config", momoConfig);
      toast.success("Cập nhật cấu hình MoMo thành công");
    } catch (error) {
      toast.error("Lỗi cập nhật cấu hình MoMo");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateBanking = async () => {
    setLoading(true);
    try {
      await api.put("/admin/settings/payment_banking_config", bankingConfig);
      toast.success("Cập nhật cấu hình Ngân hàng thành công");
    } catch (error) {
      toast.error("Lỗi cập nhật cấu hình Ngân hàng");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 sm:p-6 max-w-4xl mx-auto space-y-6 animate-fadeIn">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-black text-gray-900 dark:text-white uppercase tracking-tighter">
            Quản lý Thanh toán
          </h1>
          <p className="text-gray-500 dark:text-gray-400 text-sm mt-1">
            Thiết lập thông tin tài khoản nhận tiền từ khách hàng
          </p>
        </div>
        <button
          onClick={fetchConfigs}
          className="p-2 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-full transition-all text-gray-500"
          title="Tải lại"
        >
          <span className={`material-symbols-outlined ${loading ? 'animate-spin' : ''}`}>refresh</span>
        </button>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {/* MoMo Config */}
        <div className="bg-white dark:bg-slate-900 p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-slate-800 space-y-4">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 bg-pink-100 dark:bg-pink-900/30 rounded-xl flex items-center justify-center text-pink-600">
              <span className="material-symbols-outlined">account_balance_wallet</span>
            </div>
            <h2 className="text-lg font-bold text-gray-900 dark:text-white">Ví MoMo</h2>
          </div>

          <div className="space-y-3">
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Số điện thoại</label>
              <input
                type="text"
                value={momoConfig.phone}
                onChange={(e) => setMomoConfig({ ...momoConfig, phone: e.target.value })}
                className="w-full px-4 py-3 bg-gray-50 dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-xl outline-none focus:ring-2 focus:ring-pink-500 transition-all text-gray-900 dark:text-white font-medium"
                placeholder="0xxx xxx xxx"
              />
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Tên chủ tài khoản</label>
              <input
                type="text"
                value={momoConfig.accountHolder}
                onChange={(e) => setMomoConfig({ ...momoConfig, accountHolder: e.target.value.toUpperCase() })}
                className="w-full px-4 py-3 bg-gray-50 dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-xl outline-none focus:ring-2 focus:ring-pink-500 transition-all text-gray-900 dark:text-white font-bold uppercase"
                placeholder="NGUYEN VAN A"
              />
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Mã QR (Tùy chọn)</label>
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 bg-gray-100 dark:bg-slate-800 rounded-lg flex items-center justify-center overflow-hidden border border-gray-200 dark:border-slate-700">
                  {momoConfig.qrImage ? (
                    <img src={momoConfig.qrImage} alt="Momo QR" className="w-full h-full object-cover" />
                  ) : (
                    <span className="material-symbols-outlined text-gray-400">qr_code_2</span>
                  )}
                </div>
                <div className="flex-1">
                  <input
                    type="file"
                    id="momo-qr-upload"
                    className="hidden"
                    onChange={(e) => handleImageUpload(e.target.files[0], "momo")}
                    accept="image/*"
                  />
                  <label
                    htmlFor="momo-qr-upload"
                    className="inline-flex items-center px-4 py-2 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg text-xs font-bold text-gray-700 dark:text-gray-300 cursor-pointer hover:bg-gray-50 transition-all"
                  >
                    {uploading.momo ? "Đang tải..." : momoConfig.qrImage ? "Thay đổi QR" : "Tải lên QR cá nhân"}
                  </label>
                  {momoConfig.qrImage && (
                    <button 
                      onClick={() => setMomoConfig({...momoConfig, qrImage: ""})}
                      className="ml-2 text-red-500 text-[10px] font-bold underline"
                    >
                      Xóa
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          <button
            onClick={handleUpdateMomo}
            disabled={loading || uploading.momo}
            className="w-full py-3 bg-pink-600 hover:bg-pink-700 text-white rounded-xl font-bold transition-all shadow-lg shadow-pink-200 dark:shadow-none active:scale-[0.98] disabled:opacity-50"
          >
            Lưu cấu hình MoMo
          </button>
          <p className="text-[10px] text-gray-400 text-center italic mt-2">
            * Nếu không tải ảnh, hệ thống sẽ tự tạo mã QR theo số điện thoại trên.
          </p>
        </div>

        {/* Banking Config */}
        <div className="bg-white dark:bg-slate-900 p-6 rounded-2xl shadow-sm border border-gray-100 dark:border-slate-800 space-y-4">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 bg-blue-100 dark:bg-blue-900/30 rounded-xl flex items-center justify-center text-blue-600">
              <span className="material-symbols-outlined">account_balance</span>
            </div>
            <h2 className="text-lg font-bold text-gray-900 dark:text-white">Ngân hàng (VietQR)</h2>
          </div>

          <div className="space-y-3">
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Tên ngân hàng</label>
              <input
                type="text"
                value={bankingConfig.bankName}
                onChange={(e) => setBankingConfig({ ...bankingConfig, bankName: e.target.value })}
                className="w-full px-4 py-3 bg-gray-50 dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-xl outline-none focus:ring-2 focus:ring-blue-500 transition-all text-gray-900 dark:text-white font-medium"
                placeholder="Vd: Techcombank"
              />
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Số tài khoản</label>
              <input
                type="text"
                value={bankingConfig.accountNumber}
                onChange={(e) => setBankingConfig({ ...bankingConfig, accountNumber: e.target.value })}
                className="w-full px-4 py-3 bg-gray-50 dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-xl outline-none focus:ring-2 focus:ring-blue-500 transition-all text-gray-900 dark:text-white font-bold"
                placeholder="0000 xxxx xxxx"
              />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-bold text-gray-500 uppercase mb-1">BIN (Tạo QR)</label>
                <input
                  type="text"
                  value={bankingConfig.bin}
                  onChange={(e) => setBankingConfig({ ...bankingConfig, bin: e.target.value })}
                  className="w-full px-4 py-3 bg-gray-50 dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-xl outline-none focus:ring-2 focus:ring-blue-500 transition-all text-gray-900 dark:text-white font-medium"
                  placeholder="Vd: 970407"
                />
              </div>
              <div className="flex-1">
                <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Chủ Tài Khoản</label>
                <input
                  type="text"
                  value={bankingConfig.accountHolder}
                  onChange={(e) => setBankingConfig({ ...bankingConfig, accountHolder: e.target.value.toUpperCase() })}
                  className="w-full px-4 py-3 bg-gray-50 dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-xl outline-none focus:ring-2 focus:ring-blue-500 transition-all text-gray-900 dark:text-white font-bold uppercase"
                  placeholder="NGUYEN VAN A"
                />
              </div>
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Mã QR Ngân hàng (Tùy chọn)</label>
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 bg-gray-100 dark:bg-slate-800 rounded-lg flex items-center justify-center overflow-hidden border border-gray-200 dark:border-slate-700">
                  {bankingConfig.qrImage ? (
                    <img src={bankingConfig.qrImage} alt="Bank QR" className="w-full h-full object-cover" />
                  ) : (
                    <span className="material-symbols-outlined text-gray-400">qr_code_2</span>
                  )}
                </div>
                <div className="flex-1">
                  <input
                    type="file"
                    id="bank-qr-upload"
                    className="hidden"
                    onChange={(e) => handleImageUpload(e.target.files[0], "banking")}
                    accept="image/*"
                  />
                  <label
                    htmlFor="bank-qr-upload"
                    className="inline-flex items-center px-4 py-2 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg text-xs font-bold text-gray-700 dark:text-gray-300 cursor-pointer hover:bg-gray-50 transition-all"
                  >
                    {uploading.banking ? "Đang tải..." : bankingConfig.qrImage ? "Thay đổi QR" : "Tải lên QR cá nhân"}
                  </label>
                  {bankingConfig.qrImage && (
                    <button 
                      onClick={() => setBankingConfig({...bankingConfig, qrImage: ""})}
                      className="ml-2 text-red-500 text-[10px] font-bold underline"
                    >
                      Xóa
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>

          <button
            onClick={handleUpdateBanking}
            disabled={loading || uploading.banking}
            className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-bold transition-all shadow-lg shadow-blue-200 dark:shadow-none active:scale-[0.98] disabled:opacity-50"
          >
            Lưu cấu hình Ngân hàng
          </button>
        </div>
      </div>

      <div className="p-4 bg-yellow-50 dark:bg-yellow-900/10 border border-yellow-100 dark:border-yellow-900/30 rounded-2xl flex gap-4">
        <span className="material-symbols-outlined text-yellow-600">info</span>
        <div>
          <p className="text-sm text-yellow-800 dark:text-yellow-400 font-medium">Lưu ý quan trọng</p>
          <p className="text-xs text-yellow-700 dark:text-yellow-500 mt-1 italic">
            Các thay đổi ở đây sẽ có hiệu lực ngay lập tức tại trang đặt hàng của khách hàng. Hãy đảm bảo thông tin chính xác để tránh gián đoạn việc thanh toán.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminPayment;
